// Submodule of user module
import { getField, updateField } from "vuex-map-fields";
import { RESET, FETCH_USER_AVAILABLE_ACCES } from "@/store/action-types";
import { RESET_STATE, ERROR } from "@/store/mutation-types";
import { User } from "@/models/User";

import { RepositoryFactory, USERS_REPOSITORY } from "@/utils/RepositoryFactory";
const UsersRepository = RepositoryFactory.get(USERS_REPOSITORY);

const getDefaultState = () => ({
  entity: new User()
});

const actions = {
  [RESET]({ commit }) {
    commit(RESET_STATE);
  },
  async [FETCH_USER_AVAILABLE_ACCES]({ commit }, { userId, companyIds = [] }) {
    try {
      const { data } = await UsersRepository.getUserAcces({
        userId,
        companyIds
      });

      commit("updateUserFormAcces", data.content.acces);

      return data.content.acces;
    } catch (error) {
      commit(`app/${ERROR}`, { error, message: error.message }, { root: true });
    }
  }
};

const mutations = {
  updateField,
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState());
  },
  updateUserFormAcces(state, acces) {
    state.entity.acces = acces;
  }
};

const getters = {
  getField
};

const state = () => getDefaultState();

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state
};
